import { BoxProps, Center, HStack } from '@wegroup/design-system';
import React from 'react';
import useElementBounds from '../../../../common/src/hooks/useElementBounds';
import useMoveHubspotBubble from '../../../../common/src/hooks/support-chat/useMoveHubspotBubble';

const BottomBarWrapper: React.FC<
  React.PropsWithChildren<unknown & BoxProps>
> = ({ children, ...props }) => {
  const { setRef, height } = useElementBounds();
  useMoveHubspotBubble(height);

  return (
    <Center
      pos="sticky"
      bottom="0"
      w="100%"
      borderTop="1px"
      borderColor="gray.strokeAndBg"
      bg="white"
      ref={setRef}
      zIndex="4"
      {...props}
    >
      <HStack
        spacing="8"
        py="4"
        flexGrow={1}
        w="100%"
        px={{ base: '4', laptop: '8', desktopS: '16' }}
        justifyContent="space-between"
      >
        {children}
      </HStack>
    </Center>
  );
};

export default BottomBarWrapper;
